import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";

import LoadingSpinner from '../partials/LoadingSpinner';
import PageHeader from '../partials/PageHeader';

import NewAddressModal from './NewAddressModal';
import EditAddressModal from './EditAddressModal';
import DeleteAddressModal from './DeleteAddressModal';

import { locationsIndex, locationCreate, locationUpdate, locationDelete } from '../../redux/actions/locations';

const Locations = ({ payload, accounts, locations, loadLocations, createLocation, updateLocation, deleteLocation }) => {
  const [activeAddress, setActiveAddress] = useState(null);
  const [showEditAddressModal, setShowEditAddressModal] = useState(false);
  const [showNewAddressModal, setShowNewAddressModal] = useState(false);
  const [showDeleteAddressModal, setShowDeleteAddressModal] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    loadLocations(payload);
  }, []);

  useEffect(() => {
    if(!locations.isUpdating){
      setSubmitted(false);
    }
  }, [locations])

  const openNewAddress = () => {
    setShowNewAddressModal(true);
  }

  const openEditAddress = (id) => {
    let address = locations.locations.find(location => location.id === id);
    setActiveAddress(address);
    setShowEditAddressModal(true);
  }

  const openDeleteAddress = (id) => {
    let address = locations.locations.find(location => location.id === id);
    setActiveAddress(address);
    setShowDeleteAddressModal(true);
  }

  return(
    <>
      <PageHeader stripeBackground='#2c9c7c' helpLink="ecwid/manage-locations-and-addresses-2/" />
      
      <div className="settings-page cf">
        <div className="settings-page__header">

          <div className="named-area">
            <div className="named-area__header">
              <div className="named-area__titles">
                <div className="named-area__title">Settings</div>
              </div>
              <div className="named-area__description">
                <p>Locations are addresses and details to which purchase orders can be delivered.</p>
                <p>The "Store Locations" panel displays location data from your store, as it exists in your store right now. The information is taken live, and will update as your store is updated. When purchase orders are received at this locations, updates will be made to their inventory levels.</p>
                <p>The "Corporate Addresses" panel displays other addresses that can be used for delivery. Click the "New Address" button to create a new corporate address, or you can click the "Edit" button on any row to update that address' information, or the delete button to remove the address.</p>
                <p>The address used as your business address in purchase order PDFs is taken from one of these addresses. You can update which of these addresses is used on the <Link to="/settings">Settings page</Link>.</p>
              </div>
            </div>
            <div className="named-area__body">
              <div className="a-card-stack">

                <div className="a-card a-card--normal a-card--info-blue">
                  <div className="a-card__paddings">
                    <p>When warehouse receiving orders are created for purchase orders using a shipping address that is the your store location, that your store's inventory will be updated.</p>
                  </div>
                </div>

                <div className="a-card a-card--normal">
                  <div className="a-card__paddings">
                    <div className="flex-table">
                      <div className="flex-table__head">
                        <div className="flex-table__col flex-table__col--align-left">Label</div>
                        <div className="flex-table__col flex-table__col--align-left">Street 1</div>
                        <div className="flex-table__col flex-table__col--align-left">Street 2</div>
                        <div className="flex-table__col flex-table__col--align-left">City</div>
                        <div className="flex-table__col flex-table__col--align-left">Country</div>
                        <div className="flex-table__col flex-table__col--align-left">State</div>
                        <div className="flex-table__col flex-table__col--align-left">Zip</div>
                      </div>

                      <div className="flex-table__row">
                        <div className="flex-table__col flex-table__col--align-left">Store</div>
                        <div className="flex-table__col flex-table__col--align-left">{accounts.account.store_details.company?.street?.split('\n')[0]}</div>
                        <div className="flex-table__col flex-table__col--align-left">{accounts.account.store_details.company?.street?.split('\n')[1] || ''}</div>
                        <div className="flex-table__col flex-table__col--align-left">{accounts.account.store_details.company.city}</div>
                        <div className="flex-table__col flex-table__col--align-left">{accounts.account.store_details.company.countryCode}</div>
                        <div className="flex-table__col flex-table__col--align-left">{accounts.account.store_details.company.stateOrProvinceCode}</div>
                        <div className="flex-table__col flex-table__col--align-left">{accounts.account.store_details.company.postalCode}</div>
                      </div>
                        

                    </div>
                  </div>
                </div>

              </div>


              <div className="a-card-stack">

                { locations.status !== 'success' &&
                  <div className="a-card a-card--normal">
                    <div className="a-card__paddings">
                      <LoadingSpinner size="xxSmall" statusText="Loading locations"/>
                    </div>
                  </div>              
                }


                { locations.status === 'success' && locations.locations.length > 0 &&
                  <>
                    <div className="a-card a-card--normal a-card--info-blue">
                      <div className="a-card__paddings">
                        <p>When warehouse receiving orders are created for purchase orders using a shipping address that is a corporate address, inventory counts will NOT be updated.</p>
                      </div>
                    </div>

                    <div className="a-card a-card--normal">
                      <div className="a-card__paddings">
                        <div className="flex-table">
                          <div className="flex-table__head">
                            <div className="flex-table__col flex-table__col--align-left">Label</div>
                            <div className="flex-table__col flex-table__col--align-left">First Name</div>
                            <div className="flex-table__col flex-table__col--align-left">Last Name</div>
                            <div className="flex-table__col flex-table__col--align-left">Company</div>
                            <div className="flex-table__col flex-table__col--align-left">Street 1</div>
                            <div className="flex-table__col flex-table__col--align-left">Street 2</div>
                            <div className="flex-table__col flex-table__col--align-left">City</div>
                            <div className="flex-table__col flex-table__col--align-left">Country</div>
                            <div className="flex-table__col flex-table__col--align-left">State</div>
                            <div className="flex-table__col flex-table__col--align-left">Zip</div>
                            <div className="flex-table__col flex-table__col--align-right">Actions</div>
                          </div>

                          { locations.locations.map(location => 
                              <div className="flex-table__row">
                                <div className="flex-table__col flex-table__col--align-left">{location.label}</div>
                                <div className="flex-table__col flex-table__col--align-left">{location.first_name}</div>
                                <div className="flex-table__col flex-table__col--align-left">{location.last_name}</div>
                                <div className="flex-table__col flex-table__col--align-left">{location.company}</div>
                                <div className="flex-table__col flex-table__col--align-left">{location.street_1}</div>
                                <div className="flex-table__col flex-table__col--align-left">{location.street_2}</div>
                                <div className="flex-table__col flex-table__col--align-left">{location.city}</div>
                                <div className="flex-table__col flex-table__col--align-left">{location.country}</div>
                                <div className="flex-table__col flex-table__col--align-left">{location.state}</div>
                                <div className="flex-table__col flex-table__col--align-left">{location.zip}</div>
                                <div className="flex-table__col flex-table__col--align-right">
                                  <button className="btn btn-default" onClick={() => openEditAddress(location.id)}>
                                    <span className="svg-icon">
                                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path d="M5.0355 15.7929 2.207 12.9645 1.5 16.5l3.5355-.7071z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M12.8136.9437c.3906-.3905 1.0237-.3905 1.4143 0l2.8284 2.8284c.3905.3905.3905 1.0237 0 1.4142L5.5285 16.7141.2252 17.7748l1.0606-5.3033L12.8136.9437zm.7072 2.1213-9.8995 9.8995 1.4142 1.4142 9.8995-9.8995-1.4142-1.4142zM3.0071 15.1788l-.186-.186-.0464.2325.2324-.0465z"/></svg>
                                    </span>
                                    <span className="gwt-InlineLabel">Edit</span>
                                  </button>
                                  <button className="btn btn-default btn--destructive" onClick={() => openDeleteAddress(location.id)}>
                                    <span className="svg-icon">
                                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path fill-rule="evenodd" clip-rule="evenodd" d="M17 9A8 8 0 1 1 1 9a8 8 0 0 1 16 0Zm-4.27 4.7a6 6 0 0 1-8.796-7.916l8.795 7.917Zm1.337-1.486L5.272 4.298a6 6 0 0 1 8.795 7.916Z"/></svg>
                                    </span>
                                    <span className="gwt-InlineLabel">Disable</span>
                                  </button>
                                </div>
                              </div>
                            )
                          }
                        </div>

                        <hr/>
                        <button
                          onClick={() => openNewAddress()}
                          className={`btn btn-default ${submitted ? 'btn-loading' : ''}`}
                          disabled={submitted}
                        >
                          <span className="svg-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path d="M9.9968 8.0396h6.0302c.5374 0 .973.4356.973.973s-.4356.973-.973.973H9.9968V16c0 .5523-.4477 1-1 1h-.023c-.5523 0-1-.4477-1-1V9.9884H1.9744C1.4363 9.9884 1 9.5521 1 9.014s.4363-.9744.9744-.9744h5.9994V2c0-.5523.4477-1 1-1h.0244c.5523 0 1 .4477 1 1v6.0396h-.0014z"/></svg>
                          </span>
                          <span className="gwt-InlineLabel">New Address</span>
                        </button>
                      </div>
                    </div>
                  </>
                }

                { locations.status === 'success' && locations.locations.length === 0 &&
                  <div className="a-card a-card--normal">
                    <div className="a-card__paddings">
                      <div className="a-card a-card--vertical-compact a-card--info a-card--info-blue">
                        <div className="a-card__paddings">
                          <p>No corporate locations set. Create corporate locations to see and manage them here.</p>

                          <button
                            onClick={() => openNewAddress()}
                            className={`btn btn-default ${submitted ? 'btn-loading' : ''}`}
                            disabled={submitted}
                          >
                            <span className="svg-icon">
                              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path d="M9.9968 8.0396h6.0302c.5374 0 .973.4356.973.973s-.4356.973-.973.973H9.9968V16c0 .5523-.4477 1-1 1h-.023c-.5523 0-1-.4477-1-1V9.9884H1.9744C1.4363 9.9884 1 9.5521 1 9.014s.4363-.9744.9744-.9744h5.9994V2c0-.5523.4477-1 1-1h.0244c.5523 0 1 .4477 1 1v6.0396h-.0014z"/></svg>
                            </span>
                            <span className="gwt-InlineLabel">New Address</span>
                          </button>

                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>

          </div>
        </div>
      </div>

      { showEditAddressModal && 
        <EditAddressModal
          key={activeAddress?.id}
          payload={payload}
          showEditAddressModal={showEditAddressModal}
          setShowEditAddressModal={setShowEditAddressModal}
          address={activeAddress}
          updateLocation={updateLocation}
          setSubmitted={setSubmitted}
        />
      }

      { showNewAddressModal && 
        <NewAddressModal
          payload={payload}
          showNewAddressModal={showNewAddressModal}
          setShowNewAddressModal={setShowNewAddressModal}
          address={activeAddress}
          createLocation={createLocation}
          setSubmitted={setSubmitted}
        />
      }

      { showDeleteAddressModal && 
        <DeleteAddressModal
          key={activeAddress?.id}
          payload={payload}
          showDeleteAddressModal={showDeleteAddressModal}
          setShowDeleteAddressModal={setShowDeleteAddressModal}
          addressId={activeAddress?.id}
          deleteLocation={deleteLocation}
          setSubmitted={setSubmitted}
        />
      }

    </>
  )
}

const mapStateToProps = state => ({
  locations: state.locations,
  accounts: state.accounts,
});

const mapDispatchToProps = (dispatch) => ({
  loadLocations: (payload) => dispatch(locationsIndex(payload)),
  createLocation: (payload, location) => dispatch(locationCreate(payload, location)),
  updateLocation: (payload, location) => dispatch(locationUpdate(payload, location)),
  deleteLocation: (payload, locationId) => dispatch(locationDelete(payload, locationId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Locations);